import React, { useContext } from "react";
import { ShopifyObservedImage } from "../../components/ShopifyObservedImage";
import SubscriptionFormContext from "./SubscriptionFormContext";

interface RefillPreferenceSelectorProps {
  isSubscribingToRefills: boolean;
  onIsSubscribingToRefillsChange: (isSubscribingToRefills: boolean) => void;
}

export default function RefillPreferenceSelector({
  isSubscribingToRefills,
  onIsSubscribingToRefillsChange,
}: RefillPreferenceSelectorProps) {
  const { prices, refillPreferenceLabels, refillPreferenceImages } = useContext(
    SubscriptionFormContext
  );

  return (
    <div className="xflex xflex-col xgap-4 xmt-2">
      <div
        className="
          xblock xfont-grotesque xfont-bold xtext-3xl md:xtext-4xl
          xtext-extra-dark-green
        "
      >
        Refill preference:
      </div>
      <div className="xgrid xgrid-cols-2 xgap-4 md:xpx-8">
        <RefillPreferenceBox
          image={refillPreferenceImages.refillOnly}
          label={refillPreferenceLabels.refillOnly}
          price={prices.refillSubscriptionPrice}
          isSelected={isSubscribingToRefills}
          onSelect={() => onIsSubscribingToRefillsChange(true)}
        />
        <RefillPreferenceBox
          image={refillPreferenceImages.fullApplicator}
          label={refillPreferenceLabels.fullApplicator}
          price={prices.subscriptionPrice}
          isSelected={!isSubscribingToRefills}
          onSelect={() => onIsSubscribingToRefillsChange(false)}
        />
      </div>
      <PricingSummary isSubscribingToRefills={isSubscribingToRefills} />
    </div>
  );
}

interface RefillPreferenceBoxProps {
  image: string;
  isSelected: boolean;
  label: string;
  price: number;
  onSelect: () => void;
}

function RefillPreferenceBox({
  isSelected,
  image,
  label,
  price,
  onSelect,
}: RefillPreferenceBoxProps) {
  return (
    <div
      className={`
        xborder-4 xrounded-2xl
        xpx-4  md:xpx-8
        xpy-4
        xcursor-pointer
        xflex xgap-6 md:xgap-4
        ${isSelected ? "xborder-light-green" : "xborder-dark-green"}
        ${isSelected ? "xbg-gray/5" : "xbg-transparent"}
      `}
      onClick={onSelect}
    >
      <ShopifyObservedImage
        src={image}
        fallbackWidth={384}
        fallbackHeight={192}
        alt={label}
        className="xw-auto xh-32 md:xh-48"
      />
      <div
        className="
        xflex xflex-col xitems-start xjustify-center
        xtext-start xgap-2
        xw-full
        xfont-grotesque xtext-extra-dark-green
      "
      >
        <div
          className="
           xfont-black xtext-3xl md:xtext-4xl
        "
        >
          {label}
        </div>

        <div
          className="
           xfont-semibold xtext-2xl md:xtext-3xl
        "
        >
          ${(price / 100).toFixed(2)} / order
        </div>
      </div>
    </div>
  );
}

interface PricingSummaryProps {
  isSubscribingToRefills: boolean;
}

function PricingSummary({ isSubscribingToRefills }: PricingSummaryProps) {
  const { prices, refillPreferenceLabels } = useContext(
    SubscriptionFormContext
  );

  return (
    <div
      className="
    xflex xflex-col xgap-2 md:xgap-4
    xfont-grotesque xtext-3xl md:xtext-4xl xtext-extra-dark-green"
    >
      <div>
        <div className="xfont-bold">First order:</div>
        <div className="xfont-semibold">
          Full lip bloom, ${(prices.subscriptionPrice / 100).toFixed(2)}
        </div>
      </div>
      <div className="">
        <div className="xfont-bold">Recurring:</div>
        {isSubscribingToRefills ? (
          <div className="xfont-semibold">
            Refill only, ${(prices.refillSubscriptionPrice / 100).toFixed(2)}
          </div>
        ) : (
          <div className="xfont-semibold">
            Full lip bloom, ${(prices.subscriptionPrice / 100).toFixed(2)}
          </div>
        )}
      </div>
    </div>
  );
}
